module.exports = __webpack_public_path__ + "static/media/surtimotosdelsur.d5a71c0e.jpg";